import React from 'react'
import { css } from 'aphrodite'
import { Container } from 'reactstrap'

import PaymentsTable from './partials/PaymentsTable'
import Sitemap from '../partials/Sitemap'

import style from './style'

const sitemapHeader = [
  { url: '/info', title: 'Info' },
  { url: '/rates', title: 'Payments & Payouts' }
]

export const Rates = props => {
  return [
    <Sitemap key={0} sitemap={sitemapHeader} />,
    <section key={1} className={css(style.main.section)}>
      <Container>
        <div>
          <PaymentsTable />
          <p className={css(style.paragraphs.note)}>
            Note: Requesting early payments is also possible.
          </p>
        </div>
      </Container>
    </section>
  ]
}

export default Rates



// WEBPACK FOOTER //
// ./src/components/Rates/index.js